// Centralized branding map for domain-based theming.
import { BRAND_ASSETS } from './assets';

const GOURMEX_BRAND = {
  key: 'gourmex',
  name: 'Gourmex',
  siteTitle: 'Gourmex',
  favicon: BRAND_ASSETS.gourmex.favicon,
  mark: 'G',
  logos: {
    primary: BRAND_ASSETS.gourmex.logo,
    mark: BRAND_ASSETS.gourmex.mark,
  },
  landingVariant: 'gourmex',
  colors: {
    accent: '#7af0af',
    cta: 'linear-gradient(135deg, #0fd16a, #0c9b53)',
    markGradient: 'conic-gradient(from 120deg, #0fd16a, #0a8e46 40%, #0fd16a 80%)',
    brandText: '#dfffe8',
  },
  copy: {
    heroHeading: 'Escale seus resultados com a Gourmex',
    suiteName: 'Gourmex',
    description: 'Um único sistema para automatizar operações, enxergar indicadores e tomar decisoes com velocidade.'
  },
};

const FOODSTATION_BRAND = {
  key: 'foodstation',
  name: 'Foodstation',
  siteTitle: 'Foodstation',
  favicon: BRAND_ASSETS.foodstation.favicon,
  mark: 'F',
  logos: {
    primary: BRAND_ASSETS.foodstation.logo,
    mark: BRAND_ASSETS.foodstation.mark,
  },
  landingVariant: 'foodstation',
  colors: {
    accent: '#7af0af',
    cta: 'linear-gradient(135deg, #0fd16a, #0c9b53)',
    markGradient: 'conic-gradient(from 120deg, #0fd16a, #0a8e46 40%, #0fd16a 80%)',
    brandText: '#dfffe8',
  },
  copy: {
    heroHeading: 'Tudo integrado em um único ecossistema',
    suiteName: 'Foodstation',
    description: 'Dados centralizados, processos automatizados e inteligência aplicada para decidir melhor no dia a dia do seu restaurante.'
  },
};

const ATENDABOT_BRAND = {
  key: 'atendabot',
  name: 'AtendaBot',
  siteTitle: 'AtendaBot',
  favicon: BRAND_ASSETS.atendabot.favicon,
  mark: 'A',
  logos: {
    primary: BRAND_ASSETS.atendabot.logo,
    mark: BRAND_ASSETS.atendabot.mark,
  },
  landingVariant: 'atendabot',
  loginVariant: 'atendabot',
  authenticatedPath: '/atendabot',
  accessDeniedPath: '/atendabot/acesso-indisponivel',
  productKey: 'atendabot',
  isFood: false,
  colors: {
    accent: '#3db789',
    cta: 'linear-gradient(135deg, #322f84, #3db789)',
    markGradient: 'conic-gradient(from 120deg, #322f84, #3db789 45%, #fff1e6 80%)',
    brandText: '#fff1e6',
  },
  copy: {
    heroHeading: 'Atendimento inteligente para o seu negócio',
    suiteName: 'AtendaBot',
    description: 'Automatize conversas, organize atendimentos e ofereça respostas rápidas em todos os momentos.'
  },
};

export const BRANDING_BY_HOST = {
  'gourmex.digital': GOURMEX_BRAND,
  'foodstation.app': FOODSTATION_BRAND,
  'atendabot.com': ATENDABOT_BRAND,
};

const HOST_ALIASES = {
  'www.gourmex.digital': 'gourmex.digital',
  'www.foodstation.app': 'foodstation.app',
  'localhost': 'foodstation.app',
  '127.0.0.1': 'foodstation.app',
};

export const DEFAULT_BRAND = BRANDING_BY_HOST['foodstation.app'];
export const normalizeHostname = (hostname = '') => (
  hostname.toLowerCase().replace(/^www\./, '')
);

const getRuntimeHostname = () => (
  typeof window !== 'undefined' && window.location ? window.location.hostname : ''
);

export const resolveBranding = (hostname) => {
  const normalized = normalizeHostname(hostname);
  const mappedHost = HOST_ALIASES[normalized] || normalized;
  return BRANDING_BY_HOST[mappedHost] || DEFAULT_BRAND;
};

export const getBranding = (hostname) => (
  resolveBranding(hostname || getRuntimeHostname())
);
